styles = require './modal-window'

module.exports = (props) ->
  React.createElement("div", {"className": (styles.container)},
    React.createElement("div", {"className": (styles.data)},
      (props.children)
    )
  )
